/** Same URL detection as instruction collapsed cards and mobile instruction details. */
const URL_IN_TEXT_REGEX =
  /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi

/**
 * Wrap detectable URLs in anchor tags for display with {@link https://vuejs.org/guide/essentials/template-syntax.html#raw-html v-html}.
 */
export function convertLinks(text: string): string {
  if (!text) {
    return ""
  }
  return text.replace(
    URL_IN_TEXT_REGEX,
    '<a href="$1" target="_blank" class="underline" rel="noopener noreferrer">$1</a>'
  )
}

/**
 * Normalize pasted text while keeping single blank lines.
 * @param value Raw pasted text from the clipboard.
 * @returns Text with normalized line breaks and duplicate blank lines collapsed.
 */
export function stripDuplicateLineBreaks(value: string) {
  return (
    value
      // Convert Windows and old Mac line endings to Unix line endings.
      .replace(/\r\n?/g, "\n")
      // Convert Unicode line separator characters to normal line breaks.
      .replace(/[\u2028\u2029]/g, "\n")
      // Process the text one line at a time.
      .split("\n")
      // Collapse whitespace-only and invisible-character-only lines to empty lines.
      .map((line) => (/^[\s\u200B-\u200D\u2060\uFEFF]*$/.test(line) ? "" : line))
      // Rebuild the normalized text.
      .join("\n")
      // Reduce runs of blank lines to a single empty line.
      .replace(/\n{3,}/g, "\n\n")
  )
}
